export const NAME = 'campaignOverviewWorkspace';

export default function reducer(state = {}, action) {
    return {};
}
